import * as React from 'react';
import { useControllableState } from '../../utils/useControllableState.tsx';
import Field, { FieldProps } from './Field.tsx';

export interface IntegerFieldProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'defaultValue'>,
        FieldProps {}

export const DECIMAL_VALIDATION_REGEXP = /^(?:-?\d+(?:[.,]\d*)?|-)$/;

const IntegerField = ({
    ref,
    defaultValue,
    value: propsValue,
    onValueChange,
    onChange,
    onBlur,
    onCommit,
    controls,
    className,
    readOnly,
    disabled,
    inputRef = undefined,
    ...props
}: IntegerFieldProps) => {
    const [value, setValue] = useControllableState(defaultValue, propsValue, onValueChange);

    const handleChange = (e: any) => {
        // last char if still typing
        if (e.target.value && !DECIMAL_VALIDATION_REGEXP.test(e.target.value)) {
            e.preventDefault();
            return;
        }
        setValue(e.target.value);
        onChange?.(e);
    };

    const handleBlur = (e: any) => {
        onBlur?.(e);
        onCommit?.(value);
    };

    return (
        <Field className={className} readOnly={readOnly} disabled={disabled} ref={ref}>
            <Field.Input>
                <input
                    type="text" // type number doesn't trigger change on invalid input
                    value={value || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="px-2 py-1.5 flex-1 min-w-0 bg-surface-transparent tabular-nums outline-none"
                    inputMode="numeric"
                    readOnly={readOnly}
                    disabled={disabled}
                    {...props}
                    ref={inputRef}
                />
            </Field.Input>
            <Field.Controls>{controls}</Field.Controls>
        </Field>
    );
};

export default IntegerField;
